import {
    PaymentApi,
    PaymentController$InitiateCheckoutResult,
    PaymentController$PaymentStatusResult
} from "../api/generated/herds-licensing";
import ApiConfig from "../api/config/api-config";


export type InitiateCheckoutResult = PaymentController$InitiateCheckoutResult;
export type PaymentStatus = PaymentController$PaymentStatusResult;

export interface IPaymentService {
    initiateCheckout(breederId: string, productId: string): Promise<InitiateCheckoutResult>;

    customerPortalLink(): Promise<string>;

    status(): Promise<PaymentStatus>;
}

class PaymentServiceImpl implements IPaymentService {

    constructor(private readonly paymentApi: PaymentApi) {
    }

    async initiateCheckout(breederId: string, productId: string): Promise<InitiateCheckoutResult> {
     return this.paymentApi.initiateCheckout(breederId, productId);
    }

    async customerPortalLink(): Promise<string> {
        const result = await this.paymentApi.customerPortal();
        return result.item.customerPortalLink;
    }

    async status(): Promise<PaymentStatus> {
        const result = await this.paymentApi.status();
        return {
            creemCustomer: result?.item?.creemCustomer ?? false,
            creemActive: result?.item?.creemActive ?? false,
            pastDue: result?.item?.pastDue ?? false,
        };
    }
}

export const PaymentService = new PaymentServiceImpl(new PaymentApi(new ApiConfig()));